<template>
  <span>
    because of
    <help-center-link linkKey="payment/failed">payment failed</help-center-link>
  </span>
</template>

<script>
export default {
  name: 'PaymentFailedLink'
}
</script>

<style lang='scss'>

</style>
